<template>
    <div class="page-table  mainDiv " id="affix-container">
        <el-col :span="24" class="animated fadeInUp">
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="pkategoriTanimlama"> Partner Kategori Tanımlama
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="pkategoriList"> Partner Kategori List
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="pkategoriGuncelle"> Partner Kategori Güncelle
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="pkategoriDurumGuncelle"> Partner Kategori Durum Güncelle
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="kategoriDetay"> Partner Detay
            </el-button>
        </el-col>
        <el-col :span="24" class="animated fadeInUp">
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="partnerTanimlama"> Partner Tanımlama
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="partnerList"> Partner List
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="kategoriPartnerList"> Kategori partner List
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="partnerDetay"> Partner Detay
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="partnerGuncelle"> Partner Güncelle
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="partnerDurumGuncelle"> Partner Durum Güncelle
            </el-button>
        </el-col>
    </div>
</template>

<script>
    import partnerKategoriService from '../../../WSProvider/PartnerKategoriService';
    import partnerService from '../../../WSProvider/PartnerService';
    import notification from '../../../notification'
    import hkategoriService from "../../../WSProvider/HaberKategoriService";

    let base64 = require('base64_js');
    let userDataExon = "";
    export default {
        name: "PartnerDetay",
        methods: {
            pkategoriTanimlama() {
                let dil = {
                    en: {
                        baslik: "New",
                        seoBaslik: "New",
                        seoIcerik: "deneme"
                    }
                }
                partnerKategoriService.pkategoriTanimlama("test", "testbaslik","seob","seoi","",dil);
            },
            pkategoriDurumGuncelle() {
                partnerKategoriService.pkategoriDurumGuncelle("PK-60000", 0);
            },
            pkategoriGuncelle() {
                let updateList = [{
                    type: "baslik",
                    value: "Duyuru"
                }, {
                    type: "seoBaslik",
                    value: "Duyuru"
                }, {
                    type: "dil",
                    value: {
                        en: [{
                            type: "baslik",
                            value: "Announce"
                        }, {
                            type: "seoBaslik",
                            value: "Announce"
                        }, {
                            type: "seoIcerik",
                            value: "you can access the content of the Announce category"
                        }]
                    }
                }];
                partnerKategoriService.pkategoriGuncelle("PK-60000",updateList);
            },
            pkategoriList() {
                partnerKategoriService.pkategoriList(1);
            },
            kategoriDetay() {
                partnerKategoriService.kategoriDetay("PK-60000");
            },


            partnerTanimlama() {
                partnerService.partnerTanimlama("PK-60000", "partnertest","seob","seoi","", "HakanBt", "0850 433 33 58","","", "Teknokent","", "destek@hakanbt.com.tr", "", "www.hakanbt.com.tr", ["partner.jpg", "partner.jpg"], 1);
            },
            partnerList() {
                partnerService.partnerList(1);
            },
            kategoriPartnerList() {
                partnerService.kategoriPartnerList("PK-60000", 1);
            },
            partnerDetay() {
                partnerService.partnerDetay("PT-60000");
            },
            partnerGuncelle() {
                let updateList = [{
                    type: "partnerAdi",
                    value: "Hakan Bilgi Teknolojileri"
                }, {
                    type: "resim",
                    value: [{
                        durum: 0,
                        resim: "partner.jpg"
                    }, {
                        durum: 1,
                        resim: "partner5.jpg"
                    }]
                }];
                partnerService.partnerGuncelle("PT-60000", updateList);
            },
            partnerDurumGuncelle() {
                partnerService.partnerDurumGuncelle("PT-60000", 1);
            },

        }
    }
</script>

<style scoped>

</style>